<p class="text-error dark:text-error-darkmode">
  <ng-content />
</p>
